module.exports = __webpack_public_path__ + "img/shenhez.37b987ad.png";